import { DESTINATION_TYPES } from '../../constants/destinationTypes';
import { EntityTileProps } from '../../../../layout/interfaces/tile';
import { RawDestinationType } from '../../interfaces/destinationType';

export default function StandardDestinationTypeTilesFactory(
  destinations: any[]
): Array<EntityTileProps> {
  return destinations.map((destination, index) => {
    const { showNewBadge, showBetaBadge, ...destinationMetaData } =
      DESTINATION_TYPES[destination.dest_type];

    return {
      id: destination.dest_type,
      sortOrder: index,
      thumbnail: destination.dest_type_logo_url,
      darkModeThumbnail: destination.dest_type_dark_mode_logo_url,
      title: destination.dest_type_display,
      data: destination,
      metaData: {
        badgeMetaData: {
          showNewBadge: showNewBadge,
          showBetaBadge: showBetaBadge
        },
        ...(destinationMetaData as any)
      }
    };
  });
}
